module.exports = __webpack_public_path__ + "img/colaboracion-icon.ea092c8c.png";